import { render, staticRenderFns } from "./PasswordResetLayout.vue?vue&type=template&id=18a6b896&scoped=true"
import script from "./PasswordResetLayout.vue?vue&type=script&lang=js"
export * from "./PasswordResetLayout.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetLayout.vue?vue&type=style&index=0&id=18a6b896&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6b896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a6b896')) {
      api.createRecord('18a6b896', component.options)
    } else {
      api.reload('18a6b896', component.options)
    }
    module.hot.accept("./PasswordResetLayout.vue?vue&type=template&id=18a6b896&scoped=true", function () {
      api.rerender('18a6b896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/PasswordResetLayout.vue"
export default component.exports